<template>
  <div class="d-flex justify-space-between align-center mb-2 mt-2">
    <a-space>
      <a-button type="primary" @click="addPlan"> 添加日志 </a-button>
      <a-button type="link" @click="getData">查询数据</a-button>
    </a-space>
    <a-space>
      <a-button @click="addPlanName"> 添加项目 </a-button>
      <a-button @click="adddEmandPlan"> 添加需求计划 </a-button>
    </a-space>
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{ current: page, pageSize: limit, total: count, showQuickJumper: true, showSizeChanger: true, showTotal: (total) => `共${total}条`, }"
    @change="(pagination) => { page = pagination.current; limit = pagination.pageSize; }">
    <template #bodyCell="{ index, record, column }">
      <template v-if="column.dataIndex === 'index'">
        {{ index + 1 }}
      </template>
      <template v-if="column.dataIndex === 'plannameid'">
        {{ getName(record.plannameid) }}
      </template>
      <template v-if="column.dataIndex === 'state'">
        <span v-if="record.state && record.state === 'nostart'">未开始</span>
        <span v-if="record.state && record.state === 'unfinished'">未完成</span>
        <span v-if="record.state && record.state === 'completed'">已完成</span>
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a href="javascript:;" @click="editPlan(record)">编辑</a>
          <!-- <a-popconfirm title="确认删除？" placement="bottom" @confirm="removePlan(record._id)">
            <a href="javascript:;" style="color: red;">删除</a>
          </a-popconfirm> -->
        </a-space>
      </template>
    </template>
  </a-table>
  <!-- 新增计划事件 -->
  <a-modal v-model:visible="planModal" @ok="savePlan" @cancel="cancelSave" ok-text="确认" cancel-text="取消"
    :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false" :closable="!saving">
    <template #title>
      <a-space>
        <span>{{ planForm._id === '' ? '添加' : '编辑' }}日志</span>
      </a-space>
    </template>
    <a-form ref="planFormRef" name="planForm" :model="planForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="项目" name="plannameid" :rules="[{ required: true, message: '请选择项目' }]">
            <a-select v-model:value="planForm.plannameid" :options="planNames" placeholder="请选择项目"
              :filter-option="$filters.filterOption" show-search :disabled="saving" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="日志内容" name="content" :rules="[{ required: true, message: '请输入日志内容' }]">
            <a-textarea v-model:value="planForm.content" placeholder="日志内容" :auto-size="{ minRows: 3, maxRows: 3 }"
              :disabled="saving">
            </a-textarea>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="日期" name="startdate" :rules="[{ required: true, message: '请选择日期' }]">
            <a-date-picker v-model:value="planForm.startdate" :locale="locale" format="YYYY-MM-DD"
              value-format="YYYY-MM-DD" style="width:100%;" :disabled="saving" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="状态" name="state" :rules="[{ required: true, message: '状态不能为空' }]">
            <a-radio-group v-model:value="planForm.state" :disabled="saving">
              <a-radio value="nostart">未开始</a-radio>
              <a-radio value="unfinished">未完成</a-radio>
              <a-radio value="completed">已完成</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
  <!-- 维护项目名称 -->
  <a-modal width="850px" title="项目" v-model:visible="planNameModal" @cancel="cancelSavePlanName" cancel-text="关闭"
    :confirm-loading="saving2" :cancel-button-props="{ disabled: saving2 }" :maskClosable="false" :closable="!saving2"
    :footer="null">
    <div style="margin: auto;">
      <a-form ref="planNameFormRef" name="planNameForm" :model="planNameForm" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }">
        <a-row :gutter="8">
          <a-col :span="18">
            <a-form-item label="项目" name="name" :rules="[{ required: true, message: '请输入项目' }]">
              <a-input v-model:value="planNameForm.name" placeholder="项目" :disabled="saving2">
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-space>
              <a-popconfirm v-if="planNameForm._id" title="确认提交修改？" placement="bottom" @confirm="savePlanName">
                <a-button type="primary" html-type="submit"> 提交修改
                </a-button>
              </a-popconfirm>
              <a-popconfirm v-else title="确认添加？" placement="bottom" @confirm="savePlanName">
                <a-button type="primary" html-type="submit"> 添加
                </a-button>
              </a-popconfirm>
              <a-button html-type="submit" @click="resetNameForm"> 重置 </a-button>
            </a-space>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table :columns="columns2" bordered :data-source="planNames" :loading="dataLoading2" :scroll="{ x: width2, y: 400 }"
      :pagination="false" size="small">
      <template #bodyCell="{ index, record, column }">
        <template v-if="column.dataIndex === 'index'">
          {{ index + 1 }}
        </template>
        <template v-if="column.dataIndex === 'operation'">
          <a-space>
            <a-button type="link" @click="editPlanName(record)" :disabled="record.deleted">编辑</a-button>
            <a-popconfirm title="确认删除？" placement="left" @confirm="removeName(record._id)" :disabled="record.deleted">
              <a-button type="link" danger :disabled="record.deleted">删除</a-button>
            </a-popconfirm>
          </a-space>
        </template>
      </template>
    </a-table>
  </a-modal>
  <!-- 维护需求计划 -->
  <a-modal width="1200px" title="需求计划" v-model:visible="demandPlanModal" @cancel="cancelSaveEmandPlan" cancel-text="关闭"
    :confirm-loading="saving3" :cancel-button-props="{ disabled: saving3 }" :maskClosable="false" :closable="!saving3"
    :footer="null">
    <a-form ref="demandPlanFormRef" name="demandPlanForm" :model="demandPlanForm" :label-col="{ span: 9 }"
      :wrapper-col="{ span: 15 }">
      <a-row :gutter="16">
        <a-col :span="8">
          <a-form-item label="月份" name="month" :rules="[{ required: true, message: '请选择月份' }]">
            <a-date-picker v-model:value="demandPlanForm.month" :locale="locale" picker="month" format="YYYY-MM"
              value-format="YYYY-MM" style="width:100%;" :disabled="saving3" @change="onChangeMonth" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="产业园租户" name="count1" :rules="[{ required: true, message: '请输入产业园租户' }]">
            <a-input v-model:value="demandPlanForm.count1" placeholder="产业园租户" :disabled="saving3" suffix="家">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="合作院校" name="count3" :rules="[{ required: true, message: '请输入合作院校' }]">
            <a-input v-model:value="demandPlanForm.count3" placeholder="合作院校" :disabled="saving3" suffix="家">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="物流订单" name="count2" :rules="[{ required: true, message: '请输入物流订单' }]">
            <a-input v-model:value="demandPlanForm.count2" placeholder="物流订单" :disabled="saving3" suffix="单">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="亚马逊订单" name="count5" :rules="[{ required: true, message: '请输入亚马逊订单' }]">
            <a-input v-model:value="demandPlanForm.count5" placeholder="亚马逊订单" :disabled="saving3" suffix="单">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="Ozon订单" name="count4" :rules="[{ required: true, message: '请输入Ozon订单' }]">
            <a-input v-model:value="demandPlanForm.count4" placeholder="Ozon订单" :disabled="saving3" suffix="单">
            </a-input>
          </a-form-item>
        </a-col>
        <!-- <a-col :span="8" style="text-align: right">
            <a-form-item v-bind="{ wrapperCol: { offset: 8, span: 16, }, }">
              <a-popconfirm v-if="demandPlanForm._id" title="确认提交修改？" placement="bottom" @confirm="saveEmandPlan">
                <a-button type="primary" html-type="submit"> 提交修改
                </a-button>
              </a-popconfirm>
              <a-popconfirm v-else title="确认添加？" placement="bottom" @confirm="saveEmandPlan">
                <a-button type="primary" html-type="submit"> 添加
                </a-button>
              </a-popconfirm>
            </a-form-item>
          </a-col> -->
      </a-row>
    </a-form>
    <div class="d-flex justify-space-between align-center mb-2">
      <a-space>
        <a-button type="link" @click="getEmandPlanData">查询数据</a-button>
      </a-space>
      <a-space>
        <a-popconfirm v-if="demandPlanForm._id" title="确认提交修改？" placement="bottom" @confirm="saveEmandPlan">
          <a-button type="primary" html-type="submit"> 提交修改
          </a-button>
        </a-popconfirm>
        <a-popconfirm v-else title="确认添加？" placement="bottom" @confirm="saveEmandPlan">
          <a-button type="primary" html-type="submit"> 添加
          </a-button>
        </a-popconfirm>
        <a-button html-type="submit" @click="resetDemandPlanForm"> 重置 </a-button>
      </a-space>
    </div>
    <a-table :columns="columns3" bordered :data-source="demandPlanData" :loading="dataLoading3"
      :scroll="{ x: width3, y: 400 }" :pagination="false" size="small">
      <template #bodyCell="{ record, column }">
        <template v-if="column.dataIndex === 'operation'">
          <a-space>
            <a-button type="link" @click="editEmandPlan(record)" :disabled="record.deleted">编辑</a-button>
            <a-popconfirm title="确认删除？" placement="left" @confirm="removeEmandPlan(record._id)"
              :disabled="record.deleted">
              <a-button type="link" danger :disabled="record.deleted">删除</a-button>
            </a-popconfirm>
          </a-space>
        </template>
      </template>
    </a-table>
  </a-modal>
</template>
<script setup>
import { message } from "ant-design-vue";
import { ref, watch, computed, onActivated, getCurrentInstance, } from "vue";
import _ from "underscore";

const { proxy } = getCurrentInstance();
const planFormRef = ref();
const planNameFormRef = ref();
const demandPlanFormRef = ref();

const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const planForm = ref({});
const planModal = ref(false);
const saving = ref(false);
const continue_add = ref(false);

const dataLoading2 = ref(false);
const planNames = ref([]);
const planNameForm = ref({});
const planNameModal = ref(false);
const saving2 = ref(false);

//需求计划
const dataLoading3 = ref(false);
const demandPlanModal = ref(false);
const demandPlanForm = ref({});
const demandPlanData = ref([]);
const isThisMonth = ref(false);
const saving3 = ref(false);

const columns = computed(() => {
  return [
    { title: '项目名称', dataIndex: 'plannameid', width: 120 },
    { title: '日志内容', dataIndex: 'content', width: 150 },
    { title: '日期', dataIndex: 'startdate', width: 80 },
    { title: '状态', dataIndex: 'state', width: 80 },
    { title: '创建时间', dataIndex: 'create_time', width: 80, },
    { title: '操作', dataIndex: 'operation', width: 60, }]
});
const width = computed(() => proxy.$utils.twidth(columns.value));

const columns2 = computed(() => {
  return [
    { title: '序号', dataIndex: 'index', width: 60 },
    { title: '项目', dataIndex: 'name', width: 120 },
    { title: '创建时间', dataIndex: 'create_time', width: 80, },
    { title: '操作', dataIndex: 'operation', width: 60, }]
});
const width2 = computed(() => proxy.$utils.twidth(columns2.value));

const columns3 = computed(() => {
  return [
    { title: '计划月份', dataIndex: 'month', width: 100 },
    { title: '产业园租户(家)', dataIndex: 'count1', width: 100 },
    { title: '合作院校(家)', dataIndex: 'count3', width: 100 },
    { title: '物流订单(单)', dataIndex: 'count2', width: 100 },
    { title: '亚马逊订单(单)', dataIndex: 'count5', width: 100 },
    { title: 'Ozon订单(单)', dataIndex: 'count4', width: 100 },
    { title: '创建时间', dataIndex: 'create_time', width: 100, },
    { title: '操作', dataIndex: 'operation', width: 100, }]
});
const width3 = computed(() => proxy.$utils.twidth(columns3.value));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  getData();
  getPlanNameData();
});

const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/plan/list", { page: page.value, limit: limit.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const getName = (id) => {
  return _.findWhere(planNames.value, { value: id })?.label;
};
const initForm = () => {
  return {
    _id: "",
    plannameid: null,
    content: "",
    startdate: "",
    state: "nostart",
  };
};
const addPlan = () => {
  planForm.value = initForm();
  planModal.value = true;
};
const editPlan = (item) => {
  planForm.value = _.extend(initForm(), _.pick(item, _.keys(initForm())));
  planModal.value = true;
}
const savePlan = async () => {
  try {
    await planFormRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/plan/save", { dataForm: planForm.value }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        if (continue_add.value === false) planModal.value = false;
        message.success("保存成功");
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const removePlan = (_id) => {
  proxy.$api.doAPI("/plan/removeplan", { _id }).then((res) => {
    if (res.code === 0) {
      message.success("删除成功");
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading2.value = false;
    console.error(err);
  });
};
const cancelSave = () => {
  planFormRef.value.clearValidate();
  planModal.value = false;
};

// 维护项目名称
const getPlanNameData = () => {
  dataLoading2.value = true;
  proxy.$api.doAPI("/plan/plannamelist",).then((res) => {
    dataLoading2.value = false;
    if (res.code === 0) {
      planNames.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading2.value = false;
    console.error(err);
  });
};
const nameForm = () => {
  return {
    _id: "",
    name: "",
  };
};
const resetNameForm = () => {
  planNameForm.value = nameForm();
};
const addPlanName = () => {
  planNameForm.value = nameForm();
  planNameModal.value = true;
};
const editPlanName = (item) => {
  planNameForm.value = _.extend(nameForm(), _.pick(item, _.keys(nameForm())));
}
const savePlanName = async () => {
  try {
    await planNameFormRef.value.validateFields();
    saving2.value = true;
    proxy.$api.doAPI("/plan/savePlanName", { dataForm: planNameForm.value }).then((res) => {
      saving2.value = false;
      if (res.code === 0) {
        planNameFormRef.value.clearValidate();
        planNameForm.value = nameForm();
        message.success("保存成功");
        getPlanNameData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving2.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const removeName = (_id) => {
  proxy.$api.doAPI("/plan/removeplanname", { _id }).then((res) => {
    if (res.code === 0) {
      message.success("删除成功");
      getPlanNameData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading2.value = false;
    console.error(err);
  });
};
const cancelSavePlanName = () => {
  planNameFormRef.value.clearValidate();
  planNameModal.value = false;
};

//添加需求计划
const demandPlan = () => {
  return {
    _id: "",
    month: "",
    count1: "",
    count2: "",
    count3: "",
    count4: "",
    count5: "",
  };
};
const resetDemandPlanForm = () => {
  demandPlanForm.value = demandPlan();
};
const adddEmandPlan = () => {
  demandPlanForm.value = demandPlan();
  demandPlanModal.value = true;
  getEmandPlanData();
};
const getEmandPlanData = () => {
  dataLoading3.value = true;
  proxy.$api.doAPI("/plan/demandplanlist",).then((res) => {
    dataLoading3.value = false;
    if (res.code === 0) {
      demandPlanData.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading3.value = false;
    console.error(err);
  });
}
const onChangeMonth = () => {
  const month = new Date();
  const month1 = new Date(demandPlanForm.value.month);
  if (month.getFullYear() === month1.getFullYear() && month.getMonth() === month1.getMonth()) {
    isThisMonth.value = true;
    demandPlanForm.value.count2 = demandPlanForm.value.count2 ? demandPlanForm.value.count2 : "0";
  } else {
    isThisMonth.value = false;
  }
};
const editEmandPlan = (item) => {
  demandPlanForm.value = _.extend(demandPlan(), _.pick(item, _.keys(demandPlan())));
  onChangeMonth();
}
const saveEmandPlan = async () => {
  try {
    await demandPlanFormRef.value.validateFields();
    saving3.value = true;
    isThisMonth.value = true;
    proxy.$api.doAPI("/plan/savedemandplan", { dataForm: demandPlanForm.value }).then((res) => {
      saving3.value = false;
      isThisMonth.value = false;
      if (res.code === 0) {
        demandPlanFormRef.value.clearValidate();
        demandPlanForm.value = demandPlan();
        message.success("保存成功");
        getEmandPlanData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving3.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const removeEmandPlan = (_id) => {
  proxy.$api.doAPI("/plan/removedemandplan", { _id }).then((res) => {
    if (res.code === 0) {
      message.success("删除成功");
      getEmandPlanData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading2.value = false;
    console.error(err);
  });
};
const cancelSaveEmandPlan = () => {
  demandPlanFormRef.value.clearValidate();
  demandPlanModal.value = false;
  isThisMonth.value = false;
};


</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}
</style>